import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Calendar } from '@tds/core-decorative-icon';
import DatePicker from 'react-datepicker';
import { DateWrapper } from '../../filters/css';
import 'react-datepicker/dist/react-datepicker.css';
import { getFormattedDate, getDisabledDates } from '../../utils/utils';
import Note from '../../note';

const FieldDate = ({ data }) => {
  const {
    ref,
    value,
    placeholder,
    label,
    onChange,
    name,
    minDate,
    required,
    note,
    isShowNoteBackground,
    disableHolidays = false,
    isItalicNote
  } = data;
  return (
    <div>
      <div>
        <span className="frg-body-font-14px">
          {label}
          {required && `*`}
        </span>
      </div>
      {note && note.content && (
        <Note
          type="richText"
          isItalicNote={isItalicNote}
          data={note}
          isShowNoteBackground={isShowNoteBackground}
        />
      )}
      <DateWrapper width="100%" position="relative">
        <DatePicker
          dateFormat="yyyy/MM/dd"
          popperPlacement="top-start"
          placeholderText={placeholder}
          selected={value && moment(value).toDate()}
          filterDate={disableHolidays && getDisabledDates}
          onChange={dateValue => {
            onChange({
              target: {
                name,
                value: getFormattedDate(
                  dateValue || (value && moment(value).toDate())
                )
              }
            });
          }}
          minDate={(minDate && moment(minDate).toDate()) || 0}
        />
        <div
          style={{ position: 'absolute', top: '0.7rem', right: '0.7rem' }}
          ref={ref}
        >
          <Calendar variant="default" size={24} />
        </div>
      </DateWrapper>
    </div>
  );
};

FieldDate.propTypes = {
  data: PropTypes.shape({
    ref: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    minDate: PropTypes.string.isRequired
  }).isRequired
};

export default FieldDate;
